// AddHomeworkModal.jsx - Modal for adding new homework types
import React from 'react';
import { Plus } from 'lucide-react';

function AddHomeworkModal({ 
  show, 
  onClose, 
  newHomeworkCode, 
  setNewHomeworkCode, 
  onAdd 
}) {
  if (!show) return null;

  const handleSubmit = () => {
    onAdd();
  };

  return (
    <>
      <div
        onClick={onClose}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.5)',
          zIndex: 999
        }}
      />
      
      <div style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        background: 'white',
        borderRadius: '12px',
        padding: '32px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
        zIndex: 1000,
        minWidth: '400px'
      }}>
        <h3 style={{ margin: '0 0 16px 0', color: '#2c3e50' }}>
          Add New Homework
        </h3>
        <p style={{ color: '#7f8c8d', marginBottom: '16px', fontSize: '14px' }}>
          Enter a code for the new homework (e.g., TH5, RH5, MOCK1)
        </p>
        
        <input
          type="text"
          value={newHomeworkCode}
          onChange={(e) => setNewHomeworkCode(e.target.value)}
          placeholder="Homework code..."
          style={{
            width: '100%',
            padding: '12px',
            border: '2px solid #ecf0f1',
            borderRadius: '8px',
            fontSize: '14px',
            fontFamily: 'inherit',
            marginBottom: '16px',
            textTransform: 'uppercase'
          }}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              handleSubmit();
            }
          }}
        />
        
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{
              padding: '12px 24px',
              background: '#ecf0f1',
              color: '#2c3e50',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: '600'
            }}
          >
            Cancel
          </button>
          
          <button
            onClick={handleSubmit}
            style={{
              padding: '12px 24px',
              background: '#1b998b',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: '600',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            <Plus size={16} />
            Add Homework
          </button>
        </div>
      </div>
    </>
  );
}

export default AddHomeworkModal;